export default "__VITE_ASSET__DocBj33l__"